// @flow

import { createAction } from 'redux-actions';
import {
    INITIATE_CALL,
    SET_CALLEE,
    WS_DISPATCH_ACTION,
    SET_HELD,
    SET_MUTED,
    SET_OPERATORS,
    SET_REGISTERED,
    SET_RINGING,
    START_CALL,
    STOP_CALL,
    UPDATE_OPERATOR_PRESENCE,
    workingTabPBXActionTypes,
    SET_CALLINGS_STATE,
    SET_CALLING_ENTITY,
    TRANSFER,
    SET_SESSION_ESTABLISHED,
    SEND_DTMF_REQUEST,
    SEND_DTMF_SUCCESS, SET_START_TIME, CLEAR_COOLDOWN_STATE,
} from 'esm-web-pro/redux/callings/constants';
import type { OperatorStatus, OperatorsState } from 'esm-web-pro/redux/callings/reducer';

export const wsDispatchAction = createAction(
    WS_DISPATCH_ACTION, (payload: { type: $Keys<workingTabPBXActionTypes>, payload?: any }) => ({ payload }),
);

export const setCallingsState = createAction(
    SET_CALLINGS_STATE, (state: $Shape<CallState>) => ({ state }),
);

export const setCallingEntity = createAction(
    SET_CALLING_ENTITY, (entityUuid: string) => ({ entityUuid }),
);

export const setRegistered = createAction(
    SET_REGISTERED, (registered: boolean) => ({ registered }),
);

export const setCallee = createAction(
    SET_CALLEE, (callee: string) => ({ callee }),
);

export const setStartTime = createAction(
    SET_START_TIME, (startTime: string) => ({ startTime }),
);

export const initiateCall = createAction(
    INITIATE_CALL, (entityUuid: string, type: string, contactDetailUuid: string, taskUuid: string,
        phoneNumber?: string) => ({
        entityUuid, type, contactDetailUuid, taskUuid, phoneNumber,
    }),
);

export const setRinging = createAction(
    SET_RINGING, (callId: string, entityUuid: string, type: string,
        entityCandidates: string[], transferred: boolean = false) => ({
        entityUuid, type, entityCandidates, callId, transferred,
    }),
);

export const startCall = createAction(START_CALL);

export const stopCall = createAction(STOP_CALL);

export const setMuted = createAction(
    SET_MUTED, (muted: boolean) => ({ muted }),
);

export const setHeld = createAction(
    SET_HELD, (held: boolean, pending: boolean) => ({ held, pending }),
);

export const sendDTMFRequest = createAction(
    SEND_DTMF_REQUEST, (value: string) => ({ value }),
);

export const sendDTMFSuccess = createAction(
    SEND_DTMF_SUCCESS, (index: number) => ({ index }),
);

export const setOperators = createAction(
    SET_OPERATORS, (operators: OperatorsState) => ({ operators }),
);

export const updateOperatorPresence = createAction(
    UPDATE_OPERATOR_PRESENCE, (id: string, status: OperatorStatus) => ({ id, status }),
);

export const transfer = createAction(
    TRANSFER, (number: string) => ({ number }),
);

export const setSessionEstablished = createAction(
    SET_SESSION_ESTABLISHED, (sessionEstablished: boolean = true) => ({ sessionEstablished }),
);

export const clearCooldownState = createAction(CLEAR_COOLDOWN_STATE);
